import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TitleWithDescriptionProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import SimpleTooltip from "../tooltips/tooltip";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TitleWithDescription: React.FC<TitleWithDescriptionProps> = (props) => {
  const { title, helpText, subTitle } = props;

  return (
    <Grid container spacing={1} className={cssExports.textWithDescription}>
      <Grid container item direction={"row"}>
        <Grid item className={cssExports.title}>
          {title}
        </Grid>
        {helpText && (
          <SimpleTooltip text={helpText}>
            <Grid item className={cssExports.tooltipContent}>
              <Icon icon={IconDefinitionConstants.WInfo} className={cssExports.infoMessage} />
            </Grid>
          </SimpleTooltip>
        )}
      </Grid>
      <Grid container item className={cssExports.subTitle}>
        {subTitle}
      </Grid>
    </Grid>
  );
};

export default TitleWithDescription;
